module.exports = __webpack_public_path__ + "static/media/Komfort.fe461e3f.png";